import lazyLoading from './lazyLoading'

export default {
  name: 'Nexia Device',
  path: '/nexia',
  redirect: '/nexia/device',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false,
    group: ['admin', 'nexia']
  },
  component: lazyLoading('nexia', true),
  children: [
    {
      'name': 'Device List',
      'path': 'device',
      'meta': {
        'label': 'Device List',
        group: ['admin', 'nexia']
      },
      'component': lazyLoading('nexia/DeviceList')
    },
    {
      'name': 'Webbhook List',
      'path': 'webhook',
      'meta': {
        'label': 'Webhook List',
        group: ['admin', 'nexia']
      },
      'component': lazyLoading('nexia/WebhookList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/nexia.js